export default __webpack_public_path__ + "static/media/logo-new.61d07234.svg";